import React, { Component } from 'react';
// import { Link, Route, Switch } from 'react-router-dom';
import {getUserInfo,setUserInfoSession} from '../../Utils/UserFunctions';
import * as actions from '../../store/actions';
import Header from '../../Components/Layout/Header';
import Leftnav from '../../Components/Layout/Leftnav';
// import {ReminderPopupSneeze} from '../../Utils/CommonFunctions';
import { connect } from 'react-redux';
import withSizes from 'react-sizes';
import ReminderPopup from './ReminderPopup';
import Wrp from '../../hoc/Wrp/Wrp';
// import '../../../public/assets/css/shipCRM_login.css';
import { callPOST } from '../../Utils/ApiUtil';
import * as ShipConstants from '../../Global/Constants';

class Layout extends Component {
	constructor(props) {
		super(props);
		this.state = {
			leftMenu : [],
			totalItems : 8,
			isMinimize:false
		}
	}
	// static getDerivedStateFromProps(props, state) {
	// 	// console.log("[Layout] getDerivedStateFromProps");
	// 	console.log('state',state);
	// 	return state;
	// }
	// componentDidMount() {
		
	// 	console.log("[Layout] componentDidMount");
	// 	const windowData = getCurrentUserAuthoritiesWindow();
	// 	console.log('getCurrentUserAuthoritiesWindow',windowData);
	// 	const updateState = { ...this.state };
	// 	updateState.leftMenu = windowData;
	// 	this.setState(updateState);
	// }

	componentWillMount = () => {
		// console.log('[Layout] componentWillMount')
		const moduleId = localStorage.getItem('moduleId');
		this.props.leftMenuGenerateHandler(moduleId)
		//console.log("[Layout] shouldComponentUpdate", this.props.leftMenuGenerateHandler(moduleId));
	}

	shouldComponentUpdate = (nextProps, nextState) => {				
		return ((this.props.selectedModule !== nextProps.selectedModule) || (this.props.screenHeight !== nextProps.screenHeight) || (this.state.isMinimize !== nextState.isMinimize) );
	}

	componentDidUpdate(prevProps) {
		// console.log("[Layout] componentDidUpdate",prevProps,this.props);
	}

	// leftMenuGenerateHandler = (moduleId) => {
	// 	console.log("moduleId---------->",moduleId);
	// 	const windowData = getUserAuthoritiesWindow(moduleId);
	// 	const updateState = { ...this.state };
	// 	updateState.leftMenu = windowData;
	// 	this.setState(updateState);
	// }

	prepareReq = (val) => {
		let returnVal = null;
		const userInfo = getUserInfo();
		let pdfPref = [];
		let defaultView = '';
    const info = userInfo.data.user_preference ? userInfo.data.user_preference : null;
    if(info && info.pdf_preview_preferences) {
      pdfPref = info.pdf_preview_preferences
    }
    if(info && info.default_grid_view) {
      defaultView = info.default_grid_view
    }

    returnVal = {
    	pdf_preview_preferences : pdfPref,
    	default_grid_view : (defaultView!=='' && defaultView!==undefined && defaultView!==null)?defaultView:'LIST',
    	default_module: val
    }
    return returnVal;
	}

	changeModuleHandler = (id,val) => {
		this.props.Loader();
		const body = this.prepareReq(val);
		// console.log(JSON.stringify(body));
		
		callPOST('users/preference/update',body)
	    .then(response => {
	    	this.props.Loader();
	        const responseData = response.data;
	        // console.log(responseData);
	        if(responseData.code === ShipConstants.API_STATUS_SUCCESS) {
	          this.props.succMessage(responseData.message);
	          // console.log(responseData.data);
	          // setDefaultModuleId(id);
	          // this.props.leftMenuGenerateHandler(id);
	          setUserInfoSession(responseData);
	          // callInitialData();
	          // const pdfPref = getPdfPreferenceByWindowId(windowId);
						// console.log(pdfPref);
						// if(!iterateData[windowId]) {
							// let data = {};
							// data[windowId] = pdfPref;
							// setIterateData(data);	
						// }
	        }else {
	          this.props.failMessage(responseData.message);
	        }
      	}, (error) => {
      		this.props.Loader();
      		this.props.failMessage('Error occured!');
          	console.log(error);
      	})
	}

	showItemsHanlder = (widthSize,isMinimize) => {
		console.log(widthSize);
		let totData = 5;
		if(isMinimize === true) {
			totData = Math.trunc(widthSize/65)-2;
		}else {
			totData = Math.trunc(widthSize/28)-2;
			// if(totData > 8) {
			// 	totData = 8;
			// }
		}
		// console.log(totData,widthSize,isMinimize);
		this.setState({totalItems:totData,isMinimize:isMinimize});
	}

	render() {
		// const heightssssss = document.getElementById('sssssss').clientHeight;
		
		const isMinimize = this.state.isMinimize;
		let showItems = this.state.totalItems;
		let screenH = this.props.screenHeight;
		/*let screenH = heightssssss;
		if(screenH < 500) {
			if(this.state.isMinimize === true) {
				showItems = Math.trunc(screenH/65)-2; //47
			}else {
				showItems = Math.trunc(screenH/28)-2; //47
			}
		}*/
		if(isMinimize === true) {
			if(screenH < 350) {
				showItems = 1;
			}else if(screenH < 430) {
				showItems = 1;
			}else if(screenH < 450) {
				showItems = 2;
			}else if(screenH < 490) {
				showItems = 2;
			}else if(screenH < 561) {
				showItems = 3;
			}else if(screenH < 590) {
				showItems = 4;
			}else if(screenH < 664) {
				showItems = 5;
			}else if(screenH < 722) {
				showItems = 6;
			}else if(screenH < 780) {
				showItems = 7;
			}else {
				showItems = Math.trunc((screenH-150)/65)-2;
			}
		}else {
			if(screenH < 350) {
				showItems = 1;
			}else if(screenH < 410) {
				showItems = 2;
			}else if(screenH < 450) {
				showItems = 3;
			}else if(screenH < 490) {
				showItems = 4;
			}else if(screenH < 539) {
				showItems = 5;
			}else if(screenH < 575) {
				showItems = 6;
			}else if(screenH < 640) {
				showItems = 7;
			}else {
				showItems = Math.trunc((screenH-150)/48)-2;
			}
		}
		// console.log("showItemsqqqqqq------",showItems,isMinimize,screenH)
		// console.log("showItemsqqqqqq------",screenH,(screenH-140),window.screen.height,window.innerHeight);
		return (	
			<Wrp>
			<Header 
				leftMenuGenerate={this.props.leftMenuGenerateHandler} 
				windowData={this.props.selectedModule} 
				globalSearch={this.props.globalSearch} 
				selectedTags={this.props.selectedTags} 
				changeModuleHandler={this.changeModuleHandler} 
				onAuthenticateHandler={this.props.onAuthenticated}/>
			<Leftnav key={'webView'} menuData={this.props.selectedModule} {...this.props} screenH={screenH} showItems={showItems} showItemsHanlder={this.showItemsHanlder}/>
			<ReminderPopup />
			{/*<Content />*/}
			</Wrp>
		);
	}
} 

//export default Layout;

const mapStateToProps = (state, ownProps) => {
	return {	  
	  selectedWindowData:state.reducer.selectedWindowData,
	  selectedTags:state.reducer.selectedTags
	};
  }

const mapDispatchToProps = dispatch => {
	return {	  
	  Loader : () => dispatch(actions.loader()),	
	  leftMenuGenerateHandler:(moduleId) => dispatch({type : 'MODULE_CHANGE',moduleId:moduleId}),
	  globalSearch:(val) => dispatch({type : 'SET_SELECTED_TAGS',value:val}),
	  succMessage : (msg) => dispatch(actions.succMessage(msg)),
    failMessage : (msg) => dispatch(actions.failMessage(msg)),
    onAuthenticated : () => dispatch({type : 'LOGOUT'})
	};
}

const mapSizesToProps = ({ height }) => ({
  screenHeight: height ,
})

  export default connect(mapStateToProps, mapDispatchToProps)(withSizes(mapSizesToProps)(Layout));